import { ErroDaApi } from './client'
import { TEXTOS } from '../lib/glossario'

/**
 * A frase que vai para a tela.
 *
 * O backend já escreve suas mensagens em português, voz ativa e dizendo o que fazer —
 * usá-las é melhor do que reescrever aqui uma versão que envelhece separada. O texto
 * genérico só entra quando não veio nada aproveitável.
 *
 * @param erro qualquer coisa que tenha sido lançada
 * @returns mensagem exibível ao usuário
 */
export function mensagemDoErro(erro: unknown): string {
  if (erro instanceof ErroDaApi) {
    return erro.problema.detail ?? erro.problema.title ?? TEXTOS.erroGenerico
  }
  return TEXTOS.erroGenerico
}

/**
 * Detalhes que valem ser listados abaixo da mensagem.
 *
 * Uma RDM recusada por plano incompleto volta com `pendencias`; uma transição
 * inválida volta com `motivos`. Jogar isso fora é o que faz o usuário ver
 * "não foi possível" sem saber o que corrigir.
 *
 * @param erro qualquer coisa que tenha sido lançada
 * @returns lista de pendências ou motivos, vazia quando não houver
 */
export function detalhesDoErro(erro: unknown): string[] {
  if (!(erro instanceof ErroDaApi)) {
    return []
  }
  const { pendencias, motivos, erros } = erro.problema
  return [...(pendencias ?? []), ...(motivos ?? []), ...(erros ?? []).map((e) => `${e.campo}: ${e.mensagem}`)]
}

/** @returns o identificador da requisição, para o usuário citar ao abrir chamado. */
export function requestIdDoErro(erro: unknown): string | undefined {
  return erro instanceof ErroDaApi ? erro.problema.requestId : undefined
}
